export const SocialsList: SocialLink[] = [
    // TODO: hide for PLT-4738
    // {
    //     name: "socials.telegram",
    //     icon: "telegram",
    //     url: "https://t.me/Avocasinocom",
    // },
    // {
    //     name: "socials.x",
    //     icon: "x",
    //     url: "https://x.com/avocasinocom",
    // },
    // TODO: hide for now
    // {
    //     name: "socials.discord",
    //     icon: "discord",
    //     url: "https://www.discord.gg/avocasino",
    // },
];

interface SocialLink {
    name: string;
    icon: string;
    url: string;
}
